<template>
	<div class="ReChannelSmall mt-4">
		<div class="channel-photo">
			<img :src="channelIcon" alt class="avatar" />
		</div>
		<div class="leftCol">
			<p class="title">{{title}}</p>
			<p class="description">{{description}}</p>
			<p class="subscribers">Подписчиков {{subscribers==0?'нет':subscribers}}</p>
		</div>
		<div class="rightCol">
			<base-dropdown title-classes="btn btn-icon btn-simple btn-primary">
				<template v-slot:title>
					<i class="tim-icons icon-settings-gear-63"></i>
				</template>

				<a class="dropdown-item">Отписаться</a>
				<a class="dropdown-item">Не получать уведомления</a>
				<a class="dropdown-item" @click="GoToEdit()">Редактировать</a>
				<!--появляется для тех, у кого есть права на редактирование канала-->
				<a class="dropdown-item">Удалить канал</a>
				<!--появляется для владельца канала-->
			</base-dropdown>
		</div>
	</div>
</template>

<script>
export default {
	name: "ReChannelSmall",
	components: {},
	props: {
		title: {
			type: String,
			default: "Название канала"
		},
		description: {
			type: String,
			default: "Краткое описание канала"
		},
		subscribers: {
			type: [String, Number],
			default: "0"
		},
		channelIcon: {
			type: String,
			default: "/img/icons/icon-channel.svg"
		},
		//channel_id: ""
		objChannel: Object,
	},
	data() {
		return {
			ver: 1
		};
	},
	computed: {},
	methods: {
		GoToEdit(bGoEdit = true) {
			//this.bIsEdit = bGo;
			if (bGoEdit) {
				this.$router.push({
					path:
						"/data/line/channel/id/" + this.objChannel.id + "/edit"
				});
			} else {
				this.$router.push({ path: "/data/line/" });
			} //передалать завтра
		}
	}
};
</script>

<style scoped>
.ReChannelSmall {
	display: flex;
	flex-direction: row;
}
.channel-photo {
	margin: 0 15px;
}
.channel-photo .avatar {
	min-width: 45px;
	min-height: 45px;
	margin-bottom: 0;
	background-color: transparent;
	box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
}
.leftCol {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	padding-right: 10px;
}
.rightCol {
	display: flex;
	flex-shrink: 1;
}
.ReChannelSmall .subscribers {
	opacity: 0.4;
}
p.description {
	font-size: inherit;
}

.ReChannelSmall >>> .dropdown-menu {
	right: 0 !important;
	top: 60% !important;
	left: auto !important;
}
.ReChannelSmall >>> .dropdown-menu::before {
	right: 10px !important;
	left: auto !important;
}
</style>
